import angular from 'angular'

// components
import editGlobalOptionGroups from './component/editGlobalOptionGroups.component'

export default angular
  .module('portalApp.manage.editGlobalOptionGroups', [])
  .component('editGlobalOptionGroups', editGlobalOptionGroups)
  .name
